import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { LocationsProvider } from '../../providers/locations/locations';
import { ReserveProvider } from '../../providers/reserve/reserve';

/**
 * Generated class for the CoRoomSelectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-room-selector',
  templateUrl: 'co-room-selector.html',
})
export class CoRoomSelectorPage {

  locations: any = [];
  rooms: any = [];
  selectedLocationId: number;
  selectedLocationRooms: any = [];
  selectedTotal: number = 0;
  loaded: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, private events : Events, public locationProvider: LocationsProvider, public reserveProvider: ReserveProvider) {}

  ngOnInit() {
    this.locationProvider.getLocations().then( locations => {
      this.locations = locations;
      this.selectedLocationId = locations[0].id;
      this.reserveProvider.getAllRooms().then( rooms => {
        this.rooms = rooms;
        for(let room of rooms) {
          if(room.locationId === this.selectedLocationId) {
            room.selected = false;
            this.selectedLocationRooms.push(room);
          }
        }
        this.loaded = true;
      });
    });
  }

  locationChanged() {
    this.selectedLocationRooms = [];
    for(let room of this.rooms) {
      room.selected = false;
      if(room.locationId === this.selectedLocationId) {
        this.selectedLocationRooms.push(room);
      }
    }
  }

  updateSelectedTotal() {
    this.selectedTotal = this.selectedLocationRooms.reduce( (acc, room) => {
      return acc + room.selected;
    }, 0);
  }

  selectRooms() {
    const branches = {};
    branches[this.selectedLocationId] = this.selectedLocationRooms.filter( room => room.selected ).map( room => room.id );
    this.events.publish("SelectedRooms", branches);
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-room-selector/co-room-selector.ts